(function () {
    'use strict';

    angular
        .module('salesflare')
        .service('apikeys', apiKeysService);

    function apiKeysService(sfHttp, config) {

        this.get = function () {

            return sfHttp.get(config.apiUrl + 'apikeys', { cache: true });
        };
    }
})();
